<!-- @TODO -->
<!-- [class.component-dark-theme]="themeService.isDark()"
    [class.rtl-enabled]="themeService.isRTLEnabled()" -->
<div
  class="stat-item position-relative"

>
  <h5 style="font-size: 18px !important; font-weight: normal; color: #919aa3;">
    Partidos jugados
  </h5>
  <div class="number lh-1 fw-medium" style="font-size: 24px;">
    {{ numberPlayedGames() }} / {{ numberGames() }}
    <span style="font-size: 18px; font-weight: normal; color: #919aa3;">({{ (percentage() || 0) | number : '1.0-0' : 'en' }}%)</span>
  </div>
  <!-- <span class="daxa-up-down-badge down position-relative">
    <i class="material-symbols-outlined">
      trending_down
    </i>
    1.25%
  </span> -->
  <!-- <div class="chart">
    <apx-chart
      [series]="chartOptions.series!"
      [chart]="chartOptions.chart!"
      [xaxis]="chartOptions.xaxis!"
      [stroke]="chartOptions.stroke!"
      [tooltip]="chartOptions.tooltip!"
      [dataLabels]="chartOptions.dataLabels!"
      [colors]="chartOptions.colors!"
      [yaxis]="chartOptions.yaxis!"
      [grid]="chartOptions.grid!"
      [labels]="chartOptions.labels!"
      [legend]="chartOptions.legend!"
    ></apx-chart>
    <div class="title d-block text-body">
      Last Week
    </div>
  </div> -->
</div>
